import { Select } from 'antd';
import styled from 'styled-components';

const ColorSelect = styled(Select)`
  & .ant-select-selector {
    width: 100% !important;
    background-color: ${(props) => props.variant || 'transparent'} !important;
    border-color: #d9d9d9 !important;
  }

  & .ant-select-selection-item,
  & .ant-select-selection-placeholder {
    color: transparent !important;
  }
`;

const ColorOption = styled(Select.Option)`
  background: ${(props) => props.variant || 'transparent'} !important;
  color: transparent !important;
`;

export { ColorSelect, ColorOption };
